import { TableConfig } from "../../../../common/tables/config/TableConfig";
import { CostPayoutModifierTableRow } from "../../../../../../common/tables/cost-payout-modifier/CostPayoutModifierTableRow";
import { SortOrder } from "../../../../../../common/query-filters";
import { CellType } from "../../../../common/tables/config/CellType";

export const DefaultCPMTableConfig: TableConfig<CostPayoutModifierTableRow> = {
    columns: [
        {
            columnName: "name",
            displayName: "Name",
            cellType: CellType.textInput,
            hidden: false,
            filtered: false,
            sticky: true,
            width: "220px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "conditionCountryCode",
            displayName: "Country Code",
            cellType: CellType.textInput,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "140px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "conditionEmailDomains",
            displayName: "Email Domains",
            cellType: CellType.textInput,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "200px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "conditionIsBundle",
            displayName: "Is Bundle",
            cellType: CellType.singleSelect,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "120px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "conditionSourceName",
            displayName: "Source Name",
            cellType: CellType.textInput,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "160px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "conditionFulfillmentService",
            displayName: "Fulfillment Service",
            cellType: CellType.textInput,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "160px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "priority",
            displayName: "Priority",
            cellType: CellType.numberInput,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "120px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "createdAt",
            displayName: "Created At",
            cellType: CellType.readOnlyDate,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "140px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "updatedAt",
            displayName: "Updated At",
            cellType: CellType.readOnlyDate,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "140px",
            sortable: false,
            filterable: false,
        },
    ],
    filters: {
        expressions: [],
        sortOrder: SortOrder.DESCENDING,
        sortColumn: "priority",
        pageSize: 10,
    },
};
